import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
    portfolioByNumber,
    portfolioDetails,
    fetchSubCategories,
    fetchAssetType,
    addAssset,
    deleteAsset
} from "@/services/portfolio";
@Module({
    namespaced: true,
})
export default class Partner extends VuexModule {
    // state
    portfolioList = [];
    portfolioDataList = [];
    portfolioListMeta = [];
    assetCategoryDetails = [];
    assetTypeDetails = [];
    assetList = [];

    // actions

    @Action
    public async searchPortfolioByNumber(payload: any) {
        try {
            const data = await portfolioByNumber(payload);
            this.context.commit("portfolioSearchData", data.response);
            if (!data.response.length) {
                this.context.commit("portfolioData", []);
            }
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchPortfolioDetails(payload: any) {
        try {
            const data = await portfolioDetails(payload);
            this.context.commit("portfolioData", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchSubCategoriesAction(payload) {
        try {
            const data = await fetchSubCategories(payload);
            if(payload.category){
                this.context.commit("assetCategoryData", data.response);
            } else {
                this.context.commit("assetTypeData", data.response);
            }
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async fetchAssetTypeAction(payload) {
        try {
            const data = await fetchAssetType(payload);
            this.context.commit("assetListDetails", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async saveAssetAction(payload) {
        try {
            const data = await addAssset(payload);
            // this.context.commit("assetListDetails", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async removeAsset(payload) {
        try {
            const data = await deleteAsset(payload);
            // this.context.commit("assetListDetails", data.response);
            return data;
        } catch (error) {
            throw error;
        }
    }

    // mutations
    @Mutation
    public portfolioSearchData(data: any) {
        this.portfolioList = data;
    }
    @Mutation
    public portfolioData(data: any) {
        this.portfolioDataList = data;
    }
    @Mutation
    public assetCategoryData(data: any) {
        this.assetCategoryDetails = data;
    }
    @Mutation
    public assetTypeData(data: any) {
        this.assetTypeDetails = data;
    }
    @Mutation
    public assetListDetails(data: any) {
        this.assetList = data;
    }

    // getters
    get GetPortfolios() {
        return this.portfolioList;
    }
    get GetPortfolioDetails() {
        return this.portfolioDataList;
    }
    get GetAssetCategoryList() {
        return this.assetCategoryDetails;
    }
    get GetAssetTypeList() {
        return this.assetTypeDetails;
    }
    get GetAssetList() {
        return this.assetList;
    }
}
